import * as React from 'react';
import "./Payment.css";

import PaymentApi from "./PaymentApi";

import {paymentFields, creditCardName, eCheckNameBusiness, eCheckNameIndividual, PaymentField} from './fields/PaymentField';
import CreditCard from './fields/creditcard/CreditCard';
import Echeck from "./fields/echeck/eCheck";
import TextField from './fields/TextField';
import Amount from "./fields/Amount";
import {RefObject} from "react";
import Label from "./fields/Label";

export class Payment extends React.Component<any, any> {
  private readonly provider = new PaymentApi(this.props.nonce);
  private readonly form: RefObject<HTMLFormElement>;
  private formData = {};
  private creditCard: CreditCard;
  private eCheck: Echeck;
  private defaultAccountType: String =  'savings'
  private defaultAccountHolderType: String =  'business'

  constructor(props: any) {
    super(props);
    this.form = React.createRef();
    this.state = { errors: [], isJsError: false, onFailedError: '', account_holder_type: 'business' };
    this.formData = {account_id: this.props.fields.account, amount: this.props.fields.amount.replace('.', '')};
  }

  private onChange = (e: React.ChangeEvent<any>) => {
    const target = e.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.formData[name] = value;
  };

  private toTop = () =>{
    location.hash = '';
    location.hash = 'all-notices';
  };

  private onError = (e: any) => {
    if (!e.errors && e.messages) e.errors = e.messages;

    if(!e.errors){
      console.warn("Missing Errors Error");
      console.log(e);
      return;
    }

    this.toTop();
    this.setState({errors: e.errors})
  };

  componentDidMount(): void {
    if(this.props.fields.type === 'echeck') {
      this.formData['account_type'] = this.defaultAccountType;
      this.formData['account_holder_type'] = this.defaultAccountHolderType;
    }
  }

  selectAccountType = (event) => {
    this.formData['account_type'] = event.target.value
  }

  selectAccountHolderType = (event) => {
    this.formData['account_holder_type'] = event.target.value
    this.setState( { account_holder_type: event.target.value })
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    this.setState({ isJsError: true, onFailedError: error.message });
  }

  private submitForm = (response: any) => {
    this.formData['id'] = response.id

    if (response.type === 'ACH') {
      if(response.form_data.given_name) {
        response.given_name = response.form_data.given_name
      }
      if(response.form_data.surname) {
        response.surname = response.form_data.surname
      }
    }

    return this.provider.charge(response)
      .then(result => {
        if(this.props.receiptPage) window.location.href = this.props.receiptPage;
        this.setState({method: result.attributes.method})
      })
  };

  private formOnSubmit = () => {
    if (!this.form.current!.checkValidity()) {
      this.toTop();
      return;
    }

    if(this.props.fields.type === 'echeck') {
      this.eCheck.getPaymentToken(this.formData)
        .then(this.submitForm)
        .catch(this.onError);
    }

    if(this.props.fields.type === 'creditcard') {
      this.creditCard.getPaymentToken(this.formData)
        .then(this.submitForm)
        .catch(this.onError);
    }
  };

  private renderField = (field: PaymentField) => {
    let required = this.props.required.indexOf(field.field) > -1;
    if (!this.props.fields[field.tag] && !required) return;
    field.required = required;
    return <TextField {...field}
                      key={field.field}
                      onChange={this.onChange}/>
  };

  public render() {
    const elements = paymentFields;

    if(this.state.isJsError) {
      return <div><h3>Payment Form Error</h3>
      <span>Message: {this.state.onFailedError}</span>
      </div>
    }

    if (this.state.method) {
      return (
        <div>
          <h2>Payment Successful</h2>
          {this.state.method.email &&
          <span>An email has been sent to {this.state.method.email}</span>
          }
        </div>
      )
    }

    if(this.props.fields.type === 'creditcard') {
      return (
        <div className="Payment">
          <h1 id="all-notices">{this.props.fields.title}</h1>
          <ul>
            {this.state.errors.map((item, i) => (
              <li key={i.toString()}>{item.message || item}</li>
            ))}
          </ul>
          <div>
            <form ref={this.form}>
              <Amount
                      onChange={this.onChange}
                      amount={this.props.fields.amount}
                      amount_field={this.props.fields.amount_field}
                      amount_field_value={this.props.fields.amount_field_value}/>

              {creditCardName.map(this.renderField)}
              {elements.map(this.renderField)}

              <CreditCard
                ref={(r) => { this.creditCard = r! }}
                publicKey={this.props.publicKey}
                onChange={this.onChange}
                index={this.props.index}/>
              <button
                onClick={this.formOnSubmit}
                type="button"
                className="mb-4 mr-4 btn btn-success">{this.props.fields.button_text}</button>
            </form>
          </div>
        </div>
      )
    }

    if(this.props.fields.type === 'echeck') {
      let nameFields
      if(this.state.account_holder_type === 'business') {
        nameFields = eCheckNameBusiness.map(this.renderField)
      }
      if(this.state.account_holder_type === 'individual') {
        nameFields = eCheckNameIndividual.map(this.renderField)
      }

      return (
        <div className="Payment">
          <h1 id="all-notices">{this.props.fields.title}</h1>
          <ul>
            {this.state.errors.map((item, i) => (
              <li key={i.toString()}>{item.message || item}</li>
            ))}
          </ul>
          <div>
            <form ref={this.form}>
              <Amount
                      onChange={this.onChange}
                      amount={this.props.fields.amount}
                      amount_field={this.props.fields.amount_field}
                      amount_field_value={this.props.fields.amount_field_value}/>

              <Label htmlFor="account_holder_type" showErrors={true} error={this.state.credit_card_number}>
                Account Holder
              </Label>
              <select id="account_holder_type" onChange={this.selectAccountHolderType}>
                <option value="business">Business</option>
                <option value="individual">Individual</option>
              </select>
              <div className={`name_wrapper_${this.state.account_holder_type}`}>
                {nameFields}
              </div>
              {elements.map(this.renderField)}

              <Label htmlFor="account_type" showErrors={true} error={this.state.credit_card_number}>
                Account Type
              </Label>
              <select id="account_type" onChange={this.selectAccountType}>
                <option value="checking">Checking</option>
                <option value="savings">Savings</option>
              </select>
              <Echeck
                ref={(r) => { this.eCheck = r! }}
                publicKey={this.props.publicKey}
                onChange={this.onChange}
                index={this.props.index}/>

              <button
                onClick={this.formOnSubmit}
                type="button"
                className="mb-4 mr-4 btn btn-success">{this.props.fields.button_text}</button>

            </form>
          </div>
        </div>
      )
    }
    return (<div>Invalid charge type: ${this.props.fields.type}, only creditcard and echeck are supported</div>)
  }
}


// WEBPACK FOOTER //
// ./src/checkout/Payment.tsx